import { NgModule, Optional, SkipSelf } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { StoreDevtoolsModule } from '@ngrx/store-devtools';
import { ROOT_REDUCERS, metaReducers } from './store/core.reducer';
import { environment } from 'environments/environment';
import { AuthModule } from 'app/auth/auth.module';
import { AuthEffects } from 'app/auth/store/auth.effects';
import { MAT_SELECT_CONFIG, MatSelectConfig } from '@angular/material/select';
import { MAT_AUTOCOMPLETE_DEFAULT_OPTIONS, MatAutocompleteDefaultOptions } from '@angular/material/autocomplete';

@NgModule({
  imports: [
    CommonModule,
    HttpClientModule,

    StoreModule.forRoot(ROOT_REDUCERS, {
      metaReducers,
      runtimeChecks: {
        strictStateImmutability: true,
        strictActionImmutability: true,
        strictStateSerializability: true,
        strictActionSerializability: false
      }
    }),
    EffectsModule.forRoot([AuthEffects]),
    StoreDevtoolsModule.instrument({
      name: 'Test',
      maxAge: 5,
      logOnly: environment.production
    }),
    AuthModule
  ],
  declarations: [],
  providers: [
    // Material 15 shows a check mark on the selected option of single-choice selects and
    // autocompletes; the app never had one, so it's hidden globally.
    { provide: MAT_SELECT_CONFIG, useValue: { hideSingleSelectionIndicator: true } as MatSelectConfig },
    {
      provide: MAT_AUTOCOMPLETE_DEFAULT_OPTIONS,
      useValue: { autoActiveFirstOption: false, hideSingleSelectionIndicator: true } as MatAutocompleteDefaultOptions
    }
  ],
  exports: []
})
export class CoreModule {
  constructor(
    @Optional()
    @SkipSelf()
    parentModule: CoreModule
  ) {
    if (parentModule) {
      throw new Error('CoreModule is already loaded. Import only in AppModule');
    }
  }
}
